import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

/**
 * Validator function that checks if a string is not empty after trimming whitespace
 * and optionally validates minimum and maximum length.
 * Returns an error if the trimmed string is empty or doesn't meet length requirements.
 *
 * @param {Object} options - Validation options
 * @param {number} [options.minLength=1] - Minimum length of the trimmed string
 * @param {number} [options.maxLength] - Maximum length of the trimmed string
 * @return {ValidatorFn} A validator function that returns null if valid or ValidationErrors if invalid
 */
export function nonEmptyStringValidator(options: { minLength?: number; maxLength?: number } = {}): ValidatorFn {
	const { minLength = 1, maxLength } = options;

	return (control: AbstractControl): ValidationErrors | null => {
		if (!control.value) {
			return { nonEmptyString: { actualLength: 0, requiredMinLength: minLength } };
		}

		const trimmedValue = control.value.toString().trim();
		const trimmedLength = trimmedValue.length;

		if (trimmedLength === 0) {
			return { nonEmptyString: { actualLength: 0, requiredMinLength: minLength } };
		}

		if (trimmedLength < minLength) {
			return {
				nonEmptyStringMinLength: {
					actualLength: trimmedLength,
					requiredMinLength: minLength
				}
			};
		}

		if (maxLength && trimmedLength > maxLength) {
			return {
				nonEmptyStringMaxLength: {
					actualLength: trimmedLength,
					requiredMaxLength: maxLength
				}
			};
		}

		return null;
	};
}
